module.exports = __webpack_public_path__ + "img/details_about.6834382b.png";